import ApiService from "./ApiService";

const OrganizationService = {
    getDetailOrganization() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/organization/my').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    createOrganization(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/organization/my', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    }
};

export default OrganizationService
